import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const items = [
    "Financing India's Green Transition",
    "Asset-to-Capital Architecture",
    "Electric Mobility",
    "Green Credit Intelligence",
  ];
  return (
    <section className="py-10 md:py-14 border-y border-ink/10 bg-bg overflow-hidden" data-testid="marquee-section">
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic uppercase text-[9vw] leading-none text-stroke px-8">
              {t}
            </span>
            <span className="text-brand-green text-[6vw] px-2">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
